module.exports = __webpack_public_path__ + "media/images/sp/specials/common/recommend_aqua_flowershop-b22827639410bc1f6ddfd9062e2b0579.jpg";